import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'find',
    standalone: false
})

export class FindPipe implements PipeTransform {
  transform(array: any[], value: any, valueKey: string): any {
    return array?.find(item => item[valueKey] === value);
  }
}
